import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { AppShell } from "@/components/AppShell";
import { Loader } from "@/components/Loader";

const MOMENTS = [["mattino", "Mattino"], ["focus", "Mezzogiorno"], ["sera", "Sera"]];

function Moment({ label, m }) {
  if (!m) return null;
  return (
    <div className="mt-3">
      <p className="text-[12px] font-bold uppercase tracking-wider text-[#D4AF37]">{label}{m.titolo ? ` · ${m.titolo}` : ""}</p>
      {m.notifica && <p className="mt-1 text-sm italic text-[#A1A1AA]">Notifica: {m.notifica}</p>}
      <p className="mt-1 text-[15px] leading-relaxed text-[#E4E4E7]">{m.app}</p>
      {m.azione && <p className="mt-1 text-sm text-[#86EFAC]">Azione: {m.azione}</p>}
    </div>
  );
}

function Day({ d }) {
  return (
    <div className="rounded-2xl border border-[#27272A] bg-[#121215] p-4" data-testid={`w2-day-${d.day}`}>
      <p className="font-serif-el text-xl font-semibold text-[#FAF9F6]">Giorno {d.day} · {d.title}</p>
      {MOMENTS.map(([k, l]) => <Moment key={k} label={l} m={d[k]} />)}
      <p className="mt-3 text-sm text-[#E5C158]">Domanda: {d.domanda}</p>
      {d.lettura && (
        <div className="mt-3 rounded-xl bg-[#09090B] p-3">
          <p className="font-semibold text-[#FAF9F6]">Lettura: {d.lettura.titolo}</p>
          {d.lettura.paragrafi.map((p, i) => <p key={i} className="mt-2 text-sm leading-relaxed text-[#D4D4D8]">{p}</p>)}
          <p className="mt-2 text-sm text-[#E5C158]">{d.lettura.domanda}</p>
        </div>
      )}
      {d.esercizio && (
        <div className="mt-3 rounded-xl bg-[#09090B] p-3">
          <p className="font-semibold text-[#FAF9F6]">Esercizio: {d.esercizio.titolo} ({d.esercizio.tempo})</p>
          <p className="mt-1 text-sm text-[#D4D4D8]">{d.esercizio.obiettivo}</p>
          <ol className="mt-2 list-decimal space-y-1 pl-5 text-sm text-[#D4D4D8]">{d.esercizio.passi.map((p, i) => <li key={i}>{p}</li>)}</ol>
          <p className="mt-2 text-sm italic text-[#E5C158]">{d.esercizio.scelta}</p>
        </div>
      )}
    </div>
  );
}

export default function AdminContent() {
  const [list, setList] = useState(null);
  const [weeks, setWeeks] = useState([2]);
  const [week, setWeek] = useState(2);
  const [sel, setSel] = useState("");
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.get(`/admin/content/week/${week}`).then(({ data }) => { setList(data.profiles); setWeeks(data.weeks); setSel((s) => s || data.profiles[0]?.id); })
      .catch((e) => setErr(apiError(e.response?.data?.detail)));
  }, [week]);
  if (err) return <AppShell title="Contenuti" greeting="Area admin"><p className="p-5 text-[#FCA5A5]">{err}</p></AppShell>;
  if (!list) return <Loader />;
  const p = list.find((x) => x.id === sel);
  return (
    <AppShell title={`Settimana ${week}`} greeting="Area admin">
      <div className="space-y-3 px-5 pt-5 pb-12" data-testid="admin-content">
        <div className="flex gap-2">
          {weeks.map((w) => (
            <button key={w} onClick={() => setWeek(w)} data-testid={`week-tab-${w}`}
              className={`rounded-full border px-4 py-2 text-sm font-semibold ${w === week ? "border-[#D4AF37] bg-[#D4AF37]/15 text-[#E5C158]" : "border-[#27272A] text-[#A1A1AA]"}`}>Settimana {w}</button>
          ))}
        </div>
        <select value={sel} onChange={(e) => setSel(e.target.value)} data-testid="w2-profile-select" className="w-full rounded-xl border border-[#27272A] bg-[#09090B] px-4 py-3 text-base text-[#FAF9F6]">
          {list.map((x) => <option key={x.id} value={x.id}>{x.title} · {x.dimension} {x.level}</option>)}
        </select>
        {p && (
          <>
            <div className="rounded-2xl border border-[#D4AF37]/40 bg-[#D4AF37]/8 p-4">
              <p className="font-semibold text-[#E5C158]" data-testid="w2-week-title">{p.week_title || "Non ancora scritta"}</p>
              <p className="mt-1 text-sm text-[#D4D4D8]">{p.obiettivo}</p>
            </div>
            {p.days.map((d) => <Day key={d.day} d={d} />)}
          </>
        )}
      </div>
    </AppShell>
  );
}
